import { render, staticRenderFns } from "./GuestAmountSelection.vue?vue&type=template&id=152ceb83&lang=pug"
import script from "./GuestAmountSelection.vue?vue&type=script&lang=ts"
export * from "./GuestAmountSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports